import { render, staticRenderFns } from "./newRecord.vue?vue&type=template&id=8953ee2a"
import script from "./newRecord.vue?vue&type=script&lang=ts"
export * from "./newRecord.vue?vue&type=script&lang=ts"
import style0 from "./newRecord.vue?vue&type=style&index=0&id=8953ee2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports